import { render, staticRenderFns } from "./ControlAddedLessonsDiff.vue?vue&type=template&id=65d0d4d1&scoped=true&"
import script from "./ControlAddedLessonsDiff.vue?vue&type=script&lang=js&"
export * from "./ControlAddedLessonsDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d0d4d1",
  null
  
)

export default component.exports